import React from "react";
import { useHelpDrawer } from "../..";
import { useKnowledgeLibraryContext } from "../knowledge/KnowledgeLibraryContext";
import { useKnowledgeContext } from "../knowledge/KnowledgeContext";
export const usePortalHelpHook = () => {
  const {
    libraryResults,
    selectedLibrary,
    updateSelectedArticle,
    loadMessageKnowledgeLibrary,
    updateSelectedLibrary,
    selectCategory,
    clearSelectedArticle,
    clearSelectedLibrary,
    SUBCATEGORY_CHAR
  } = useKnowledgeLibraryContext();
  const {
    libraries
  } = useKnowledgeContext();
  const [messageKnowledgebase, setMessageKnowledgebase] = React.useState({});
  const [reloadOnClose, setReloadOnClose] = React.useState(false);
  const [portalHelpKB, setPortalHelpKB] = React.useState(null);
  const {
    isDrawerOpen
  } = useHelpDrawer();
  const [categoryToLoad, setCategoryToLoad] = React.useState();
  const [articleToLoad, setArticleToLoad] = React.useState();
  React.useEffect(() => {
    //make sure library has finished loading before selecting a category/article
    if (!libraryResults.loading && selectedLibrary.groupName) {
      if (categoryToLoad) {
        selectCategory(categoryToLoad);
        setCategoryToLoad(null);
      }
      if (articleToLoad) {
        updateSelectedArticle({
          label: articleToLoad,
          focusArticleAttention: true
        });
        setArticleToLoad(null);
      }
    }
  }, [libraryResults.loading, categoryToLoad, articleToLoad]);
  React.useEffect(() => {
    if (!isDrawerOpen) {
      clearSelectedLibrary();
      clearSelectedArticle();
      if (reloadOnClose && messageKnowledgebase.groupName) {
        setReloadOnClose(false);
        updateSelectedLibrary(messageKnowledgebase);
      }
    } else {
      if (selectedLibrary.groupName !== portalHelpKB.groupName) {
        setReloadOnClose(true);
        setMessageKnowledgebase(selectedLibrary);
        loadMessageKnowledgeLibrary(portalHelpKB);
      }
    }
  }, [isDrawerOpen]);
  React.useEffect(() => {
    if (!libraries.loading && libraries.publicLibraries.length) {
      //there should only be one configured per portal
      const {
        tenantName,
        groupName
      } = libraries.publicLibraries[0];
      setPortalHelpKB({
        tenantName,
        groupName
      });
    }
  }, [libraries]);
  const isHelpAvailable = React.useMemo(() => portalHelpKB === null ? false : true, [portalHelpKB]);
  const showCategory = (category, subCategory) => {
    const newCategory = {
      label: subCategory ? `${SUBCATEGORY_CHAR} ${subCategory}` : category,
      value: category,
      category: {
        category
      }
    };
    setCategoryToLoad(newCategory);
  };
  const selectArticle = article => {
    setArticleToLoad(article);
  };
  const openManagerHelp = (category, subCategory, article) => {
    if (article) {
      selectArticle(article);
    }
    if (category) {
      clearSelectedArticle();
      showCategory(category, subCategory);
    }
  };
  return {
    showCategory,
    selectArticle,
    openManagerHelp,
    isHelpAvailable
  };
};